import EnhancedProductService from "../services/enhanced/EnhancedProductService";
import EnhancedLocalStorage from "../services/enhanced/EnhancedLocalStorage";
import { sectionFactory } from "../services/enhanced/models";
import CompatibleProductsService from "../services/CompatibleProductsService";
import DOMService from "../services/DOMService";
//import { imagesTransformation } from "../services/enhanced/ImagesUtility";

export default {
  namespaced: true,
  state: {
    seriesId: "",
    enhancedProductData: null,
    configurationId: "0",
    testTogSectionEditMode: false,
    // non mock state items
    sections: {},
    selectedOptions: {},
    updatedProductData: null,
    isEnhancedPDP: false,
    IsSectionAvailable: true,
    // set to true when we should get the next section
    // set back to false when we have retrieved the next section
    updatingNextSection: false,
    variantCode: "",
    enhancedSeriesId: "",
    isOptionsLoading: true,
    isAllSectionsCompleted: false,
    isProductFirstLoad: true,
    cutoutPositionsForValidation: {},
    saveAndContinueItem: null,
    hasError: false,
    resetToFirstImage: false,
    isScreenSizeMobile: null,
    isCustomConfigurationSelected: false,
    tools: null,
    displayTools: null,
    isCustomHPL: false,
    isOtherCustomHPL: false,
    customHPLData: [],
    customHPLFormData: [],
    productVariantCharacteristics: null
  },
  getters: {
    isOptionsLoading: state => state.isOptionsLoading,
    hasError: state => state.hasError,
    getEnhancedProductData: state => state.enhancedProductData,
    getEnhancedProductSeries: state =>
      state.enhancedProductData && state.enhancedProductData.Series,
    getEnhancedDisplayProduct: state =>
      state.enhancedProductData && state.enhancedProductData.DisplayProduct,
    showEnhancedOption: state =>
      state.enhancedProductData
        ? state.enhancedProductData.DisplayProductOptions
        : false,
    getEnhancedPDPOptions: state => {
      if (!state.enhancedProductData) {
        return state.enhancedProductData;
      }
      return state.enhancedProductData.EnhancedPdpOptions;
    },
    getEnhancedProductBanner: state => {
      if (state.enhancedProductData?.SelectedSku?.Banner?.[0]) {
        return state.enhancedProductData?.SelectedSku?.Banner?.[0];
      } else if (
        !state.enhancedProductData?.SelectedSku &&
        state.enhancedProductData?.Series?.Banner?.[0]
      ) {
        return state.enhancedProductData?.Series?.Banner?.[0];
      } else {
        return null;
      }
    },
    getEnhancedProductTitle(state, getters) {
      const { getEnhancedProductData } = getters;
      if (
        getEnhancedProductData &&
        getEnhancedProductData.SelectedSku &&
        getEnhancedProductData.SelectedSku.Title
      )
        return getEnhancedProductData.SelectedSku.Title;
      else if (
        getEnhancedProductData &&
        getEnhancedProductData.Series &&
        getEnhancedProductData.Series.Title
      )
        return getEnhancedProductData.Series.Title;
      else return "";
    },
    getEnhancedProductDescription(state, getters) {
      const { getEnhancedProductData } = getters;
      if (
        getEnhancedProductData &&
        getEnhancedProductData.SelectedSku &&
        getEnhancedProductData.SelectedSku.Description
      )
        return getEnhancedProductData.SelectedSku.Description;
      else if (
        getEnhancedProductData &&
        getEnhancedProductData.Series &&
        getEnhancedProductData.Series.Description
      )
        return getEnhancedProductData.Series.Description;
      else return "";
    },
    getEnhancedZoomerImages: (state, getters, rootState, rootGetters) => {
      let validBom;
      const enhancedBOM = rootGetters["enhancedBom/getBomSourceOfTruth"];

      if (enhancedBOM && enhancedBOM.length > 0) {
        validBom = enhancedBOM.filter(
          x => x.Images && x.Images.Thumbs.length > 0
        );
      }

      if (validBom && validBom.length > 0) {
        let allImages = {
          LargeSize: [],
          MediumSize: [],
          NormalSize: [],
          Thumbs: []
        };
        validBom.forEach(x => {
          allImages.LargeSize = allImages.LargeSize.concat(x.Images.LargeSize);
          allImages.MediumSize = allImages.MediumSize.concat(
            x.Images.MediumSize
          );
          allImages.NormalSize = allImages.NormalSize.concat(
            x.Images.NormalSize
          );
          allImages.Thumbs = allImages.Thumbs.concat(x.Images.Thumbs);
        });

        //add videos from series
        if (
          getters.getEnhancedProductData.Series &&
          getters.getEnhancedProductData.Series.Videos != null &&
          getters.getEnhancedProductData.Series.Videos.Thumbs.length > 0
        ) {
          // Large Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.LargeSize.length;
            i++
          ) {
            allImages.LargeSize.push(
              getters.getEnhancedProductData.Series.Videos.LargeSize[i]
            );
          }
          // Thumbs
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.Thumbs.length;
            i++
          ) {
            allImages.Thumbs.push(
              getters.getEnhancedProductData.Series.Videos.Thumbs[i]
            );
          }

          // Normal Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.NormalSize.length;
            i++
          ) {
            allImages.NormalSize.push(
              getters.getEnhancedProductData.Series.Videos.NormalSize[i]
            );
          }

          // Medium Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.MediumSize.length;
            i++
          ) {
            allImages.MediumSize.push(
              getters.getEnhancedProductData.Series.Videos.MediumSize[i]
            );
          }
        }

        for (let i = 0; i < allImages.Thumbs.length; i++) {
          allImages.Thumbs[i].id = i;
        }
        for (let i = 0; i < allImages.NormalSize.length; i++) {
          allImages.NormalSize[i].id = i;
        }
        for (let i = 0; i < allImages.LargeSize.length; i++) {
          allImages.LargeSize[i].id = i;
        }
        for (let i = 0; i < allImages.MediumSize.length; i++) {
          allImages.MediumSize[i].id = i;
        }
        return allImages;
      } else if (
        getters.getEnhancedProductData &&
        getters.getEnhancedProductData.SelectedSku &&
        getters.getEnhancedProductData.SelectedSku.Images != null &&
        getters.getEnhancedProductData.SelectedSku.Images.Thumbs.length > 0
      ) {
        let allImages = getters.getEnhancedProductData.SelectedSku.Images;

        if (
          getters.getEnhancedProductData.Series &&
          getters.getEnhancedProductData.Series.Videos != null &&
          getters.getEnhancedProductData.Series.Videos.Thumbs.length > 0 &&
          getters.getEnhancedProductData.Series.Images.Thumbs[0].id ===
            undefined
        ) {
          // Large Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.LargeSize.length;
            i++
          ) {
            allImages.LargeSize.push(
              getters.getEnhancedProductData.Series.Videos.LargeSize[i]
            );
          }
          // Thumbs
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.Thumbs.length;
            i++
          ) {
            allImages.Thumbs.push(
              getters.getEnhancedProductData.Series.Videos.Thumbs[i]
            );
          }

          // Normal Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.NormalSize.length;
            i++
          ) {
            allImages.NormalSize.push(
              getters.getEnhancedProductData.Series.Videos.NormalSize[i]
            );
          }

          // Medium Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.MediumSize.length;
            i++
          ) {
            allImages.MediumSize.push(
              getters.getEnhancedProductData.Series.Videos.MediumSize[i]
            );
          }
        }

        for (let i = 0; i < allImages.Thumbs.length; i++) {
          allImages.Thumbs[i].id = i;
        }
        for (let i = 0; i < allImages.NormalSize.length; i++) {
          allImages.NormalSize[i].id = i;
        }
        for (let i = 0; i < allImages.LargeSize.length; i++) {
          allImages.LargeSize[i].id = i;
        }
        for (let i = 0; i < allImages.MediumSize.length; i++) {
          allImages.MediumSize[i].id = i;
        }

        return allImages;
      } else if (
        getters.getEnhancedProductData &&
        getters.getEnhancedProductData.Series &&
        getters.getEnhancedProductData.Series.Images != null &&
        getters.getEnhancedProductData.Series.Images.Thumbs.length > 0
      ) {
        let allImages = getters.getEnhancedProductData.Series.Images;

        if (
          getters.getEnhancedProductData.Series &&
          getters.getEnhancedProductData.Series.Videos != null &&
          getters.getEnhancedProductData.Series.Videos.Thumbs.length > 0 &&
          getters.getEnhancedProductData.Series.Images.Thumbs[0].id ===
            undefined
        ) {
          // Large Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.LargeSize.length;
            i++
          ) {
            allImages.LargeSize.push(
              getters.getEnhancedProductData.Series.Videos.LargeSize[i]
            );
          }
          // Thumbs
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.Thumbs.length;
            i++
          ) {
            allImages.Thumbs.push(
              getters.getEnhancedProductData.Series.Videos.Thumbs[i]
            );
          }

          // Normal Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.NormalSize.length;
            i++
          ) {
            allImages.NormalSize.push(
              getters.getEnhancedProductData.Series.Videos.NormalSize[i]
            );
          }

          // Medium Size
          for (
            let i = 0;
            i < getters.getEnhancedProductData.Series.Videos.MediumSize.length;
            i++
          ) {
            allImages.MediumSize.push(
              getters.getEnhancedProductData.Series.Videos.MediumSize[i]
            );
          }
        }

        for (let i = 0; i < allImages.Thumbs.length; i++) {
          allImages.Thumbs[i].id = i;
        }
        for (let i = 0; i < allImages.NormalSize.length; i++) {
          allImages.NormalSize[i].id = i;
        }
        for (let i = 0; i < allImages.LargeSize.length; i++) {
          allImages.LargeSize[i].id = i;
        }
        for (let i = 0; i < allImages.MediumSize.length; i++) {
          allImages.MediumSize[i].id = i;
        }
        return allImages;
      }

      /**
        If we reach this point there is no main image and we need to provide a fallback
       **/
      const defaultImage = {
        Url:
          "https://res.cloudinary.com/avd/image/upload/v1576013897/ProductPage/General/No-Image.jpg",
        Title: "No Photo Available"
      };

      return {
        Thumbs: [defaultImage],
        NormalSize: [defaultImage],
        LargeSize: [defaultImage]
      };
    },
    getConfigurationId: state => state.configurationId,
    getTestTogSectionEditMode: state => state.testTogSectionEditMode,
    // this gets all the state we need for enhanced products
    // we are using this getter to set local storage
    getEnhancedSuperState: (state, getters, rootState) => ({
      seriesId: rootState.product.seriesId,
      enhancedproduct: state,
      enhancedBom: rootState.enhancedBom,
      prodspecification: rootState.prodspecification
    }),
    getProductData: state => state.updatedProductData,
    getSeriesId: state => state.seriesId,
    getEnhancedSeriesId: state => state.enhancedSeriesId,
    getVariantCode: state => state.variantCode,
    getIsEnhancedPDP: state => state.isEnhancedPDP,
    getSections: state => state.sections,
    getSelectedOptions: state => state.selectedOptions,
    getUpdatingNextSection: state => state.updatingNextSection,
    getIsSectionAvailable: state => state.IsSectionAvailable,
    getIsAllSectionsCompleted: state => state.isAllSectionsCompleted,
    getProductVariantCharacteristics: state =>
      state.productVariantCharacteristics,
    getEnhancedImage: (state, getters) => {
      var product = getters.getEnhancedProductData;
      if (product == null) {
        return { Url: "", Title: "" };
      }

      /**
        this image handles the case where no image is provided
       **/
      var image = [
        {
          Url:
            "https://res.cloudinary.com/avd/image/upload/v1576013897/ProductPage/General/No-Image.jpg",
          Title: "No Photo Available"
        }
      ];
      if (
        product &&
        product.SelectedSku &&
        product.SelectedSku.Images &&
        product.SelectedSku.Images.LargeSize.length > 0
      ) {
        image = product.SelectedSku.Images.LargeSize;
      } else if (
        product &&
        product.Series &&
        product.Series.Images &&
        product.Series.Images.LargeSize.length > 0
      ) {
        image = product.Series.Images.LargeSize;
      }

      return image;
    },
    getSectionsNumberOfOptionalChoices: (_state, getters) => {
      const sectionsObj = getters.getSections;
      // the object keys are sequential 1, 2, 3 etc
      const sectionKeys = Object.keys(sectionsObj);
      // sort the keys so largest is 1st and take the 1st
      const currentSectionKey = sectionKeys.sort((a, b) => b - a)[0];
      // gets the array of sectionOptionValues and makes a count of the number of optional dropdowns
      const currentSectionValues =
        sectionsObj[currentSectionKey].sectionOptionValues;
      const optionalValueCount = currentSectionValues.reduce((acc, value) => {
        if (true === value.IsOptional) {
          acc++;
        }
        return acc;
      }, 0);
      return optionalValueCount;
    },
    getIsProductFirstLoad: state => state.isProductFirstLoad,
    getSaveAndContinueItem: state => state.saveAndContinueItem,
    getResetToFirstImage: state => state.resetToFirstImage,
    getIsScreenSizeMobile: state => state.isScreenSizeMobile,
    getEnhancedTools: state => state.tools,
    showPrices: (state, _getters, _rootState, rootGetters) => {
      const isNotCustom = !state.isCustomConfigurationSelected;
      const pleaseSelectOptionsMsgNotShowing = !rootGetters[
        "enhancedBom/getShowPleaseSelectOptionsMsg"
      ];
      const hasFinishedBeenClicked =
        rootGetters["enhancedBom/getHasFinishedBeenClicked"];

      return (
        (isNotCustom || hasFinishedBeenClicked) &&
        pleaseSelectOptionsMsgNotShowing
      );
    },
    getIsCustomHPL: state => state.isCustomHPL,
    getIsOtherCustomHPL: state => state.isOtherCustomHPL,
    getcustomHPLData: state => state.customHPLData,
    getcustomHPLFormData: state => state.customHPLFormData
  },
  mutations: {
    UPDATE_IS_OPTIONS_LOADING(state, value) {
      state.isOptionsLoading = value;
    },
    UPDATE_ERROR(state, bool) {
      state.hasError = bool;
    },
    UPDATE_SERIES_ID(state, seriesId) {
      state.seriesId = seriesId;
    },
    UPDATE_ENHANCED_SERIES_ID(state, enhancedSeriesId) {
      state.enhancedSeriesId = enhancedSeriesId;
    },
    UPDATE_VARIANT_CODE(state, variantCode) {
      state.variantCode = variantCode;
    },
    GET_ENHANCED_PRODUCT_DATA(state, data) {
      state.enhancedProductData = data;
    },
    SET_CONFIGURATION_ID(state, configurationId) {
      state.configurationId = configurationId;
    },
    TEST_TOG_SECTION_EDIT_MODE(state) {
      state.testTogSectionEditMode = !state.testTogSectionEditMode;
    },
    SET_UPDATED_PRODUCT_DATA(state, data) {
      state.updatedProductData = data;
    },

    ADD_SECTION(state, data) {
      // find an option where both properties are valid
      const options = data.allOptions;
      const validOption =
        options && options.length > 0
          ? options.find(option => option.RulesKey && option.EnhancedSectionId)
          : [];
      const sectionId = validOption.EnhancedSectionId;
      const SectionLabel = data.sectionHeader;
      const section = sectionFactory(
        sectionId,
        SectionLabel,
        data.IsNextSectionAvailable,
        false,
        options,
        data.CallBOM,
        data.IsCustomSection
      );
      this._vm.$set(state.sections, validOption.EnhancedSectionId, section);

      let _tmpSelectedOptions = state.selectedOptions[
        validOption.EnhancedSectionId
      ]
        ? state.selectedOptions[validOption.EnhancedSectionId]
        : {};
      this._vm.$set(
        state.selectedOptions,
        validOption.EnhancedSectionId,
        _tmpSelectedOptions
      );

      state.IsSectionAvailable = data.IsNextSectionAvailable;
      let _tmpVal = {};

      options.map(option => {
        if (option.Values) {
          option.Values.map(value => {
            if (value.Position) {
              value.Position.map(() => {
                _tmpVal[value.RulesKey] = {};
              });
              value.Position.map(pos => {
                _tmpVal[value.RulesKey][pos.PositionValue] = "";
              });
            }
          });
        }
      });

      this._vm.$set(
        state.sections[validOption.EnhancedSectionId],
        "cutoutPositionsForValidation",
        _tmpVal
      );
    },
    CHANGE_UPDATING_NEXT_SECTION(state, bool) {
      state.updatingNextSection = bool;
    },
    SET_IS_ENHANCED_PDP(state, bool) {
      state.isEnhancedPDP = bool;
    },
    UPDATE_SELECTED_OPTION(state, data) {
      let _tmpSelectedOptions = state.selectedOptions;
      let selectedOption = data.selectedOption;
      if (_tmpSelectedOptions[selectedOption.EnhancedSectionId]) {
        _tmpSelectedOptions[selectedOption.EnhancedSectionId][
          selectedOption.RulesKey
        ] = selectedOption;
        if (!data.isOptional) {
          deleteOutOfSequenceOptionSelections(
            _tmpSelectedOptions,
            selectedOption
          );
        }

        state.selectedOptions = { ..._tmpSelectedOptions };
      }
    },
    DELETE_SELECTED_OPTION_CUSTOM_HPL(state, data) {
      let _tempRulesKey = data.RulesKey;
      let _tempId = data.Id;
      let _selectedOptionsCopy = JSON.parse(
        JSON.stringify(state.selectedOptions)
      );
      if (state.customHPLFormData && state.customHPLFormData.length > 0) {
        for (let i = 0; i < state.customHPLFormData.length; i++) {
          if (state.customHPLFormData[i].RulesKey !== _tempRulesKey) {
            let _selectedOptions = JSON.parse(
              JSON.stringify(state.selectedOptions)
            );
            delete _selectedOptions[2][_tempRulesKey];
            state.selectedOptions = { ..._selectedOptions };
          }
          if (
            state.customHPLFormData[i].RulesKey === _tempRulesKey &&
            state.customHPLFormData[i].Id !== _tempId
          ) {
            let _selectedOptions = JSON.parse(
              JSON.stringify(state.selectedOptions)
            );
            delete _selectedOptions[2][_tempRulesKey];
            state.customHPLFormData.splice([i], 1);
            state.selectedOptions = { ..._selectedOptions };
          }
          if (
            state.customHPLFormData[i].RulesKey === _tempRulesKey &&
            state.customHPLFormData[i].Id === _tempId
          ) {
            state.selectedOptions = { ..._selectedOptionsCopy };
          }
        }
      } else {
        let _selectedOptions = JSON.parse(
          JSON.stringify(state.selectedOptions)
        );
        delete _selectedOptions[2][_tempRulesKey];
        state.selectedOptions = { ..._selectedOptions };
      }
    },
    UPDATE_SELECTED_CUTOUT_POSITION(state, selectedPosition) {
      let _tmpSelectedOptions = JSON.parse(
        JSON.stringify(state.selectedOptions)
      );
      if (_tmpSelectedOptions[selectedPosition.EnhancedSectionId]) {
        _tmpSelectedOptions[selectedPosition.EnhancedSectionId][
          selectedPosition.Value
        ] = selectedPosition;
      }

      this._vm.$set(
        state.selectedOptions,
        selectedPosition["EnhancedSectionId"],
        _tmpSelectedOptions[selectedPosition.EnhancedSectionId]
      );
    },
    UPDATE_SECTION_COMPLETE(state, EnhancedSectionId) {
      let _tmpSections = state.sections;
      _tmpSections[EnhancedSectionId].isComplete = true;
      this._vm.$set(
        state.sections,
        EnhancedSectionId,
        _tmpSections[EnhancedSectionId]
      );
    },
    CLEAR_SELECTED_OPTIONS(state) {
      this._vm.$set(state, "selectedOptions", {});
      this._vm.$set(state, "configurationId", "0");
      this._vm.$set(state, "sections", []);
      this._vm.$set(state, "isAllSectionsCompleted", false);
    },
    UNSET_SELECTED_OPTIONS_FOR_POSITION(state, values) {
      for (const option in state.selectedOptions[values.sectionId]) {
        if (
          state.selectedOptions[values.sectionId] &&
          state.selectedOptions[values.sectionId][option] &&
          state.selectedOptions[values.sectionId][option]["RulesKey"] ==
            values.selectedRulesKey
        ) {
          this._vm.$delete(state.selectedOptions[values.sectionId], option);
        }
      }
    },
    UNSET_SELECTED_OPTION(state, option) {
      const { RulesKey, EnhancedSectionId } = option;
      if (
        state.selectedOptions[EnhancedSectionId] &&
        state.selectedOptions[EnhancedSectionId][RulesKey]
      ) {
        this._vm.$delete(state.selectedOptions[EnhancedSectionId], RulesKey);
      }
    },
    SET_IS_ALLSECTIONS_COMPLETED(state) {
      this._vm.$set(state, "isAllSectionsCompleted", true);
    },
    MARK_IS_PRODUCT_FIRST_LOAD(state) {
      state.isProductFirstLoad = false;
    },
    UNSET_CUTOUT_POSITION_VALIDATION(state, values) {
      if (values.checked) {
        this._vm.$set(
          state.sections[values.sectionId]["cutoutPositionsForValidation"][
            values.rulesKey
          ],
          values.positionKey,
          values.value
        );
      } else {
        this._vm.$set(
          state.sections[values.sectionId]["cutoutPositionsForValidation"][
            values.rulesKey
          ],
          values.positionKey,
          ""
        );
      }
    },
    UPDATE_SAVE_AND_CONTINUE_ITEM(state, item) {
      state.saveAndContinueItem = item;
    },
    RESET_TO_FIRST_IMAGE(state, bool) {
      state.resetToFirstImage = bool;
    },
    UPDATE_IS_SCREEN_SIZE_MOBILE(state, value) {
      state.isScreenSizeMobile = value;
    },
    RESTORE_STATE_FROM_LOCAL_STORAGE(state, data) {
      Object.assign(state, data.enhancedProduct);
    },
    SET_IS_CUSTOM_CONFIGURATION_SELECTED(state, bool) {
      state.isCustomConfigurationSelected = bool;
    },
    UPDATE_TOOLS(state, newTools) {
      state.tools = newTools;
    },
    CLEAR_TOOLS(state) {
      this._vm.$set(state, "tools", null);
      this._vm.$set(state, "displayTools", null);
    },
    SET_PRODUCT_VARIANT_CHARACTERISTICS(state, data) {
      if (
        state.productVariantCharacteristics &&
        Object.keys(state.productVariantCharacteristics).length !== 0
      ) {
        if (
          JSON.stringify(
            data.productVariantCharacteristics.VARIANT_CHARACTERISTICS
          ) !==
          JSON.stringify(
            state.productVariantCharacteristics.VARIANT_CHARACTERISTICS
          )
        ) {
          let _tempProductVariantCHarData = JSON.parse(
            JSON.stringify(state.productVariantCharacteristics)
          );

          for (
            let i = 0;
            i <
            data.productVariantCharacteristics.VARIANT_CHARACTERISTICS.length;
            i++
          ) {
            _tempProductVariantCHarData.VARIANT_CHARACTERISTICS.push(
              data.productVariantCharacteristics.VARIANT_CHARACTERISTICS[i]
            );
          }

          state.productVariantCharacteristics.VARIANT_CHARACTERISTICS = [
            ..._tempProductVariantCHarData.VARIANT_CHARACTERISTICS
          ];
        }
      } else {
        state.productVariantCharacteristics =
          data.productVariantCharacteristics;
      }
    },
    UPDATE_IS_CUSTOMHPL(state, bool) {
      state.isCustomHPL = bool;
    },
    UPDATE_IS_OTHERCUSTOMHPL(state, bool) {
      state.isOtherCustomHPL = bool;
    },
    UPDATE_CUSTOMHPL_DATA(state, customHPLData) {
      state.customHPLData = customHPLData;
    },
    UPDATE_CUSTOMHPL_FORM_DATA(state, customHPLFormData) {
      if (customHPLFormData.RulesKey !== null) {
        let id = customHPLFormData.Id;
        let rulesKey = customHPLFormData.RulesKey;
        let checkOne = state.customHPLFormData.some(el => {
          return el.Id === id && el.RulesKey === rulesKey;
        });
        let checkTwo = state.customHPLFormData.some(el => {
          return el.RulesKey === rulesKey;
        });
        if (checkOne) {
          state.customHPLFormData.splice(-1, 1);
        } else if (checkTwo) {
          state.customHPLFormData.splice(-1, 1);
        }
        state.customHPLFormData.push(customHPLFormData);
      }
    },
    DELETE_CUSTOMHPL_FORM_DATA(state, data) {
      if (data.Id && data.RulesKey) {
        if (state.customHPLFormData.length > 0) {
          for (let i = 0; i < state.customHPLFormData.length; i++) {
            if (
              state.customHPLFormData[i].Id === data.Id &&
              state.customHPLFormData[i].RulesKey === data.RulesKey
            ) {
              state.customHPLFormData.splice([i], 1);
            }
          }
        }
      }
    },
    CLEAR_CUSTOMHPL_FORM_DATA(state, data) {
      state.customHPLFormData = data;
    },
    CLEAR_CUSTOMHPL_DATA(state, data) {
      state.customHPLData = data;
    },
    CLEAR_PRODUCT_VARIANT_CHARACTERISTICS(state, data) {
      state.productVariantCharacteristics = data;
    }
  },
  actions: {
    loadEnhancedProductData({ commit, getters }, { seriesId, skuId }) {
      return EnhancedProductService.getEnhancedProductData(seriesId, skuId)
        .then(response => response.data)
        .then(data => {
          commit("GET_ENHANCED_PRODUCT_DATA", data);
          // dispatch("updateEnhancedLocalStorage");
        })
        .then(() => {
          if (true === getters.getIsProductFirstLoad) {
            DOMService.ReplaceSearchResultsText(
              getters.getEnhancedProductTitle
            );
            const productData = getters.getEnhancedProductData;
            let displaySelectSkuMessage = false;
            displaySelectSkuMessage =
              productData &&
              productData.SelectedSku == null &&
              productData.Series &&
              !productData.Series.HasCompatibleProducts;
            DOMService.showHideSelectSkuMsg(displaySelectSkuMessage);
            CompatibleProductsService.fireProductLoadedEvent(productData);
            CompatibleProductsService.showCompatibleProducts();
            commit("MARK_IS_PRODUCT_FIRST_LOAD");
            //Hiding skeleton from MVC side of things
            let MvcSkeleton = document.getElementById("MvcSkeleton");
            if (MvcSkeleton) MvcSkeleton.setAttribute("style", "display: none");
          }
        })
        .catch(e => {
          throw e;
        });
    },
    testTogSectionEditMode({ commit }) {
      commit("TEST_TOG_SECTION_EDIT_MODE");
    },
    updateEnhancedLocalStorage({ getters }) {
      EnhancedLocalStorage.setEnhancedLocalStorage(
        getters.getEnhancedSuperState
      );
    },
    setIsEnhancedPDP({ commit }, { isPageEnhanced }) {
      commit("SET_IS_ENHANCED_PDP", isPageEnhanced);
    },
    setSeriesId({ commit }, { seriesId }) {
      commit("UPDATE_SERIES_ID", seriesId);
    },
    setEnhancedSeriesId({ commit }, { enhancedSeriesId }) {
      commit("UPDATE_ENHANCED_SERIES_ID", enhancedSeriesId);
    },
    setVariantCode({ commit }, { variantCode }) {
      commit("UPDATE_VARIANT_CODE", variantCode);
    },
    setConfigId({ commit }, { Configurationid }) {
      commit("SET_CONFIGURATION_ID", Configurationid);
    },
    setIsAllSectionsCompleted({ commit }) {
      commit("SET_IS_ALLSECTIONS_COMPLETED");
    },
    unsetSelectedOptionsForPosition({ commit }, values) {
      commit("UNSET_SELECTED_OPTIONS_FOR_POSITION", values);
    },
    setProductVariantCharacteristics({ commit }, values) {
      commit("SET_PRODUCT_VARIANT_CHARACTERISTICS", values);
    },
    setCutoutPositionValidation(
      { commit },
      { rulesKey, sectionId, checked, positionKey, value }
    ) {
      commit("UNSET_CUTOUT_POSITION_VALIDATION", {
        rulesKey,
        sectionId,
        checked,
        positionKey,
        value
      });
    },
    async updatedSectionEnhancedProductOptionValues(
      { state, commit, getters, dispatch },
      { SectionId, VariantCode, UpdatingSection, OptionIndex }
    ) {
      // this boolean is used to make sure the skeleton is only showing when a new section is loading
      const isUpdateWithinTheSection = true === UpdatingSection;
      const optionIndex = OptionIndex === 0 ? 1 : OptionIndex ? OptionIndex : 0;

      if (!isUpdateWithinTheSection) {
        commit("UPDATE_IS_OPTIONS_LOADING", true);
      }
      const enhancedSeriesId = getters.getEnhancedSeriesId;
      const Configurationid = state.configurationId;
      return await EnhancedProductService.fetchSectionEnhancedProductOptionValues(
        enhancedSeriesId,
        Configurationid,
        SectionId,
        VariantCode,
        getters.getSelectedOptions,
        true
      )
        .then(response => response.data)
        .then(data => {
          const allOptions = data.AllOptions;
          const CallBOM = data.CallBOM;
          const sectionHeader = data.SectionHeader;
          const IsNextSectionAvailable = data.IsNextSectionAvailable;
          const IsCustomConfigurationSelected =
            data.IsCustomConfigurationSelected;
          const IsCustomSection = data.IsCustomSection;

          commit(
            "SET_IS_CUSTOM_CONFIGURATION_SELECTED",
            IsCustomConfigurationSelected
          );

          commit("ADD_SECTION", {
            allOptions,
            IsNextSectionAvailable,
            CallBOM,
            sectionHeader,
            IsCustomSection
          });
        })
        .then(() => {
          if (
            getters.getSections &&
            getters.getSections[SectionId] &&
            getters.getSections[SectionId].sectionOptionValues &&
            getters.getSections[SectionId].sectionOptionValues.length > 0
          ) {
            for (
              let i = optionIndex;
              i < getters.getSections[SectionId].sectionOptionValues.length;
              i++
            ) {
              if (
                getters.getSections[SectionId].sectionOptionValues[i].Values &&
                getters.getSections[SectionId].sectionOptionValues[i].Values
                  .length === 1 &&
                !getters.getSections[SectionId].sectionOptionValues[i]
                  .IsOptional
              ) {
                if (
                  getters.getSections[SectionId].sectionOptionValues[i]
                    .RulesKey == "ConfigurationId"
                ) {
                  dispatch("setConfigId", {
                    Configurationid:
                      getters.getSections[SectionId].sectionOptionValues[i]
                        .Values[0].Value
                  });
                }
                if (
                  getters.getSections[SectionId].sectionOptionValues[i].IsPart
                ) {
                  dispatch(
                    "enhancedBom/setBomParts",
                    {
                      selectedOption:
                        getters.getSections[SectionId].sectionOptionValues[i]
                          .Values[0]
                    },
                    //Third parm added to dispatch to enhancedBom.js, store to store, action to action
                    {
                      root: true
                    }
                  );
                }
                dispatch("updatedSelectedOption", {
                  selectedOption:
                    getters.getSections[SectionId].sectionOptionValues[i]
                      .Values[0]
                });
              } else if (
                getters.getSections[SectionId].sectionOptionValues[i]
                  .DependentProperty &&
                getters.getSections[SectionId].sectionOptionValues[i]
                  .DependentProperty.length > 0 &&
                !getters.getSections[SectionId].sectionOptionValues[i]
                  .IsOptional
              ) {
                const filteredOptions = filterOptionValuesByDependentProperty(
                  getters.getSections[SectionId].sectionOptionValues[i],
                  getters.getSelectedOptions
                );
                if (filteredOptions.length === 1) {
                  dispatch("updatedSelectedOption", {
                    selectedOption: filteredOptions[0]
                  });
                } else {
                  break;
                }
              } else {
                break;
              }
            }
          }
        })
        .then(() => {
          if (!isUpdateWithinTheSection) {
            commit("UPDATE_IS_OPTIONS_LOADING", false);
          }
        })
        .catch(() => {
          commit("UPDATE_IS_OPTIONS_LOADING", false);
          commit("UPDATE_ERROR", true);
        });
    },
    restoreStateFromLocalStorage({ commit }, enhancedProduct) {
      commit("RESTORE_STATE_FROM_LOCAL_STORAGE", {
        enhancedProduct
      });
    },

    updateFetchError({ commit }, { error }) {
      commit("UPDATE_ERROR", error);
    },

    updatedSelectedOption({ commit }, selectedOption) {
      commit("UPDATE_SELECTED_OPTION", selectedOption);
    },
    DeleteSelectedOptionCustomHPL({ commit }, selectedOption) {
      commit("DELETE_SELECTED_OPTION_CUSTOM_HPL", selectedOption);
    },
    unsetSelectedOption({ commit }, option) {
      commit("UNSET_SELECTED_OPTION", option);
    },

    updatedSelectedCutoutPosition({ commit }, { selectedPosition }) {
      commit("UPDATE_SELECTED_CUTOUT_POSITION", selectedPosition);
    },

    updateSectionComplete({ commit }, { EnhancedSectionId }) {
      commit("UPDATE_SECTION_COMPLETE", EnhancedSectionId);
    },

    changeUpdatingNextSection({ commit }, bool) {
      commit("CHANGE_UPDATING_NEXT_SECTION", bool);
    },

    clearSelectedOptions({ commit }, productData) {
      commit("CLEAR_SELECTED_OPTIONS", productData);
      CompatibleProductsService.fireProductClearAllEvent(productData);
    },
    saveAndContinue({ dispatch, getters, rootGetters }, item) {
      const EnhancedSectionId = item.sectionId;
      if (
        getters.getSelectedOptions[EnhancedSectionId] &&
        getters.getSections[EnhancedSectionId]
      ) {
        dispatch("updateSectionComplete", {
          EnhancedSectionId: EnhancedSectionId
        });

        if (item.IsNextSectionAvailable) {
          dispatch("updatedSectionEnhancedProductOptionValues", {
            SectionId: parseInt(EnhancedSectionId) + 1,
            VariantCode: getters.getVariantCode
          });
        }

        if (!item.IsNextSectionAvailable) {
          dispatch("setIsAllSectionsCompleted", {
            EnhancedSectionId: EnhancedSectionId
          });
        }

        if (item.CallBOM) {
          dispatch(
            "enhancedBom/updatedSectionEnhancedProducBillOfMaterials",
            {
              seriesId: getters.getSeriesId,
              Configurationid: getters.getConfigurationId,
              SectionId: parseInt(EnhancedSectionId),
              VariantCode: getters.getVariantCode,
              selectedOptions: getters.getSelectedOptions,
              bomParts: rootGetters["enhancedBom/getBomParts"]
            },
            { root: true }
          );
        }
      }
    },
    updateSaveAndContinueItem({ commit }, item) {
      commit("UPDATE_SAVE_AND_CONTINUE_ITEM", item);
    },
    updateError({ commit }, bool) {
      commit("UPDATE_ERROR", bool);
    },
    resetToFirstImage({ commit }, bool) {
      commit("RESET_TO_FIRST_IMAGE", bool);
    },
    updateIsScreenSizeMobile({ commit }, value) {
      commit("UPDATE_IS_SCREEN_SIZE_MOBILE", value);
    },
    loadProductTools({ commit }, { seriesId, skuId }) {
      return EnhancedProductService.fetchTools(seriesId, skuId)
        .then(({ data }) => data)
        .then(data => {
          return commit("UPDATE_TOOLS", data);
        })
        .catch(e => {
          // TODO: error handling
          throw e;
        });
    },
    clearProductTools({ commit }) {
      return commit("CLEAR_TOOLS");
    },
    setIsCustomHPL({ commit }, bool) {
      commit("UPDATE_IS_CUSTOMHPL", bool);
    },
    setIsOtherCustomHPL({ commit }, bool) {
      commit("UPDATE_IS_OTHERCUSTOMHPL", bool);
    },
    setCustomHPLData({ commit }, customHPLData) {
      commit("UPDATE_CUSTOMHPL_DATA", {
        Id: customHPLData.Id,
        RulesKey: customHPLData.RulesKey,
        ReferenceUrl: customHPLData.ReferenceUrl,
        ReferenceText: customHPLData.ReferenceText,
        ColorNamePlaceholder: customHPLData.ColorNamePlaceholder,
        ColorNumberPlaceholder: customHPLData.ColorNumberPlaceholder,
        ManufacturerPlaceholder: customHPLData.ManufacturerPlaceholder
          ? customHPLData.ManufacturerPlaceholder
          : null,
          ColorNumberNote: customHPLData.ColorNumberNote
          ? customHPLData.ColorNumberNote
          : null
      });
    },
    setCustomHPLFormData({ commit }, customHPLFormData) {
      commit("UPDATE_CUSTOMHPL_FORM_DATA", {
        Id: customHPLFormData.Id,
        RulesKey: customHPLFormData.RulesKey,
        ColorName: customHPLFormData.ColorName,
        ColorNumber: customHPLFormData.ColorNumber,
        Manufacturer: customHPLFormData.Manufacturer
          ? customHPLFormData.Manufacturer
          : null
      });
    },
    deleteCustomHPLFormData({ commit }, value) {
      commit("DELETE_CUSTOMHPL_FORM_DATA", value);
    },
    clearCustomHPLFormData({ commit }, value) {
      commit("CLEAR_CUSTOMHPL_FORM_DATA", value);
    },
    clearCustomHPLData({ commit }, value) {
      commit("CLEAR_CUSTOMHPL_DATA", value);
    },
    clearProductVariantCharacteristics({ commit }, value) {
      commit("CLEAR_PRODUCT_VARIANT_CHARACTERISTICS", value);
    }
  }
};

// helper functions

function deleteOutOfSequenceOptionSelections(optionsObject, selectedOption) {
  const { EnhancedSectionId, RulesKey } = selectedOption;
  // selected options exist on the options object under the property of the EnhancedSectionId
  // selectedKeys is an array of the selected properties
  const selectedKeys = Object.keys(optionsObject[EnhancedSectionId]);

  // finds the index of the current selectedOption in the selectedKeys
  const indexOfSelectedKey = selectedKeys.findIndex(key => key === RulesKey);

  // indexOfSelectedKeyAtArrayEnd adds 1 to indexOfSelectedKey so we can compare to the selected keys length
  const indexOfSelectedKeyAtArrayEnd = indexOfSelectedKey + 1;

  // if indexOfSelectedKeyAtArrayEnd is not at the end of selectedKeys, it has been previously selected
  const previouslySelected =
    selectedKeys.length !== indexOfSelectedKeyAtArrayEnd;

  // we need to remove selections that occour after our selection
  if (previouslySelected) {
    // gives us an array of selections after our current selection
    const keysToRemove = selectedKeys.slice(indexOfSelectedKey + 1);
    // deletes those selections from our options object
    keysToRemove.forEach(selection => {
      // added selection not equals finishID in the condition - For this use case:if user selects custom hpl
      //and did'nt not enter the values we clear the finish but the wilsonart/formica.
      //But since it was clicked before it is stored and the next option is auto populated if the next selection is only one,
      // for that that case it is added here in mutations: deleteselectedoptionCustomHPL
      // therefore this condition is added to remove any collisions with that logic.
      if (selection !== "FinishId") {
        delete optionsObject[EnhancedSectionId][selection];
      }
    });
  }
}

// Loops through all the options in that section and if only one option then it preselects the option
function filterOptionValuesByDependentProperty(options, selectedOptions) {
  const _tmpSelectedOptions = selectedOptions;
  let filteredOptions = options.Values.filter(option => {
    let _valuesCount = 0;
    for (let i = 0; i < option.DependentPropertyValues.length; i++) {
      if (option.DependentPropertyValues[i]) {
        for (const key in _tmpSelectedOptions) {
          for (const optionKey in _tmpSelectedOptions[key]) {
            if (
              _tmpSelectedOptions[key][optionKey] &&
              _tmpSelectedOptions[key][optionKey].Value ==
                option.DependentPropertyValues[i]["Value"] &&
              _tmpSelectedOptions[key][optionKey].RulesKey ==
                option.DependentPropertyValues[i]["Key"]
            ) {
              _valuesCount++;
            }
          }
        }
      }
      if (_valuesCount == option.DependentPropertyValues.length) {
        return true;
      } else {
        return false;
      }
    }
  });

  return filteredOptions;
}
